var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove-btn text-12",on:{"click":_vm.handleShowDeleteDialog}},[_c('icon-delete'),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }